import styled from 'styled-components';

export const ToolsContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
`;

export const ToolsContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    min-height: 0;
`;

export const ToolsHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    height: 60px;
    padding: 0 24px;
    border-bottom: 1px solid #e2e8f0;
    background-color: white;
    flex-shrink: 0;
`;

export const ToolsTitle = styled.h1`
    font-size: 24px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
`;

export const TabsContentContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
`;

export const HeaderSpacer = styled.div`
    flex: 1;
`;

export const TabsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
`;
